module.exports = __webpack_public_path__ + "images/for_company_guide/company_guide_sample_39b89f0040157dce3e87920c02746f0d.svg";